export default {
  width: 21,
  height: 25,
  svg: `
    <path d="M6.292 6.25a4.208 4.208 0 1 1 8.416 0 4.208 4.208 0 0 1-8.416 0ZM10.5.042a6.208 6.208 0 1 0 0 12.416 6.208 6.208 0 0 0 0-12.416Zm0 14.583c-3.38 0-5.952 1.057-7.695 2.489-1.706 1.4-2.68 3.222-2.68 4.761v2.083a1 1 0 0 0 1 1h18.75a1 1 0 0 0 1-1v-2.083c0-1.534-.974-3.356-2.68-4.757-1.742-1.432-4.314-2.493-7.695-2.493Zm-8.375 7.25c0-.763.55-2.066 1.949-3.215 1.361-1.119 3.477-2.035 6.426-2.035 2.948 0 5.064.919 6.426 2.038 1.4 1.151 1.949 2.454 1.949 3.212v1.083H2.125v-1.083Z"/>
  `
}
